import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';

const LineChartRechart = ({ data, xField, yField, title, height = 300, width }) => {
    return (
        <div className="lineChartWrapper"> 
            <h2 style={{textAlign:'center'}}>{title}</h2>
        <LineChart width={width} height={height} data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey={xField} />
          <YAxis />
          <Tooltip />
          <Legend />
          <Line type="monotone" dataKey={yField} stroke="#8884d8" />
        </LineChart>
        </div>
    );
};

export default LineChartRechart;